module.exports = __webpack_public_path__ + "assets/smart-asset-template-role.9c1fb2e6.svg";